import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomformComponentDef } from '@df/catalog-ui/customform/customform.component.def';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { CheckboxComponent } from '../../ui/form/checkbox';
import { CustomFormPcaPredictComponent } from '../../ui/form/custom-form-pca-predict/custom-form-pca-predict.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../../ui/form/mui-input.directive';
import { RadioComponent } from '../../ui/form/radio';

@Component({
    selector: 'customform',
    templateUrl: './customform.component.html',
    standalone: true,
    imports: [
        ActionComponent,
        CheckboxComponent,
        CommonModule,
        CustomFormPcaPredictComponent,
        FormsModule,
        InputWrapBodyDirective,
        InputWrapComponent,
        MuiInputDirective,
        RadioComponent,
        RadioGroupDirective,
        ResultComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomformComponent extends CustomformComponentDef<{}> {
    @Input()
    sku?: string;

    override dataReset(): void {
        super.dataReset();

        if (this.sku && this.model) {
            const subjectField = this.model.data?.fields.find(field => field.label === 'Subject');

            if (subjectField) {
                this.data[subjectField.cid] = 'Product code: ' + this.sku;
            }
        }
    }
}
